export class InvoicesSearch {
  constructor() {
    this.selectedIndexes = [];
    Object.values(InvoicesChecksDefinition).forEach((item) => {
      this.selectedIndexes[item.index] = item.defaultChecked;
    });
  }
  searchKey?: string;
  id?: string;
  client?: string;
  reviewedBy?: string;
  reportDateCompleted?: Date;
  selectedIndexes: boolean[];
}

export class InvoiceCheckDefinition {
  constructor(
    label: string,
    defaultChecked: boolean,
    column: number,
    index: number
  ) {
    this.label = label;
    this.defaultChecked = defaultChecked;
    this.column = column;
    this.index = index;
  }
  label: string;
  defaultChecked: boolean;
  column: number;
  index: number;
}

export const InvoicesChecksDefinition = {
  reportTitle: new InvoiceCheckDefinition('Report Title', false, 7, 0),
  claimantLastName: new InvoiceCheckDefinition('Last Name', true, 1, 1),
  claimantFirstName: new InvoiceCheckDefinition('First Name', true, 1, 2),
  claimNumber: new InvoiceCheckDefinition('Claim Number', true, 1, 3),
  reportDueDate: new InvoiceCheckDefinition('Report Due Date', true, 2, 5),
  reportDateCompleted: new InvoiceCheckDefinition(
    'Report Date Completed',
    true,
    2,
    61
  ),
  closedDate: new InvoiceCheckDefinition('Case Closed Date', true, 2, 76),
  requestedReviewerSpecialty1: new InvoiceCheckDefinition(
    'Reviewer Specialty 1',
    false,
    4,
    62
  ),
  requestedReviewerSpecialty2: new InvoiceCheckDefinition(
    'Reviewer Specialty 2',
    false,
    5,
    63
  ),
  requestedReviewerSpecialty3: new InvoiceCheckDefinition(
    'Reviewer Specialty 3',
    false,
    6,
    64
  ),
  requestedReviewerSpecialty4: new InvoiceCheckDefinition(
    'Reviewer Specialty 4',
    false,
    7,
    65
  ),
  requestedReviewerSpecialty5: new InvoiceCheckDefinition(
    'Reviewer Specialty 5',
    false,
    7,
    66
  ),
  benefitState: new InvoiceCheckDefinition(
    'State of Jurisdiction',
    true,
    2,
    9
  ),
  reviewedBy: new InvoiceCheckDefinition('Reviewed By', true, 3, 10),
  referralNumber: new InvoiceCheckDefinition('Referral Number', true, 3, 11),
  reportDeterminationDate: new InvoiceCheckDefinition(
    'Report Determination Date',
    false,
    3,
    12
  ),
  rush: new InvoiceCheckDefinition('Rush', false, 3, 13),
  contact: new InvoiceCheckDefinition('Contact', false, 3, 14),
  numberOfRequests: new InvoiceCheckDefinition(
    'Number Of Requests',
    false,
    4,
    15
  ),
  pageCount: new InvoiceCheckDefinition('Page Count', true, 4, 16),
  reasonsForRequest: new InvoiceCheckDefinition(
    'Reasons For Request',
    false,
    4,
    17
  ),
  outcomeOfReview: new InvoiceCheckDefinition(
    'Outcome Of Review',
    false,
    4,
    18
  ),
  sameDay: new InvoiceCheckDefinition('SameDay', false, 5, 22),
  claimantClient: new InvoiceCheckDefinition('Client Name', true, 5, 23),
  employerName: new InvoiceCheckDefinition('Employer Name', false, 5, 24),
  insuranceCarrier: new InvoiceCheckDefinition(
    'Insurance Carrier',
    false,
    6,
    25
  ),
  referralSource: new InvoiceCheckDefinition('Referral Source', false, 6, 26),
  externalAdjuster: new InvoiceCheckDefinition(
    'External Adjuster',
    false,
    6,
    27
  ),
  physicianSpecialty: new InvoiceCheckDefinition(
    'Physician Specialty',
    false,
    6,
    29
  ),
  referralDate: new InvoiceCheckDefinition('Referral Date', true, 7, 30),

  callAttempts: new InvoiceCheckDefinition('Call Attempts', false, 7, 33),
  stradixNumber: new InvoiceCheckDefinition('Stradix Number', true, 1, 34),
  lineOfBusiness: new InvoiceCheckDefinition('Line Of Business', true, 2, 35),
  service: new InvoiceCheckDefinition('Service', true, 3, 36),
  subService: new InvoiceCheckDefinition('Sub Service', true, 4, 37),
  claimantGender: new InvoiceCheckDefinition('Gender', false, 5, 38),
  claimantStreetAddress: new InvoiceCheckDefinition(
    'Claimant Street Address',
    false,
    6,
    39
  ),
  claimantCity: new InvoiceCheckDefinition('City', false, 7, 40),
  claimantState: new InvoiceCheckDefinition('State', false, 1, 41),
  claimantZipCode: new InvoiceCheckDefinition('Zip Code', false, 2, 42),
  claimantEmail: new InvoiceCheckDefinition('Email', false, 3, 43),
  dateOfInjury: new InvoiceCheckDefinition(
    'Date of Injury/Disability',
    false,
    4,
    44
  ),
  dateOfRequest: new InvoiceCheckDefinition('Date Of Request', true, 5, 45),
  dateOfExam: new InvoiceCheckDefinition('Date Of Exam', false, 6, 46),
  claimantDateOfBirth: new InvoiceCheckDefinition('Date Of Birth', false, 7, 47),
  tatPriority: new InvoiceCheckDefinition('TAT Priority', false, 1, 48),
  tat: new InvoiceCheckDefinition('TAT', false, 2, 49),
  jurisditionalMatchRequired: new InvoiceCheckDefinition(
    'Jurisditional Match Required',
    false,
    3,
    50
  ),
  apContactPreference: new InvoiceCheckDefinition(
    'AP Contact Preference',
    false,
    2,
    51
  ),
  numberOfReviews: new InvoiceCheckDefinition('Number Of Reviews', false, 5, 52),
  referralStatus: new InvoiceCheckDefinition('Referral Status', true, 7, 53),
  attorneyName: new InvoiceCheckDefinition('Attorney Name', false, 7, 55),
  apName1: new InvoiceCheckDefinition('AP Name 1', false, 1, 56),
  apName2: new InvoiceCheckDefinition('AP Name 2', false, 2, 57),
  apName3: new InvoiceCheckDefinition('AP Name 3', false, 3, 58),
  apName4: new InvoiceCheckDefinition('AP Name 4', false, 4, 59),
  apName5: new InvoiceCheckDefinition('AP Name 5', false, 5, 60),
  apSpecialty1: new InvoiceCheckDefinition('AP Specialty 1', false, 1, 67),
  apSpecialty2: new InvoiceCheckDefinition('AP Specialty 2', false, 2, 68),
  apSpecialty3: new InvoiceCheckDefinition('AP Specialty 3', false, 3, 69),
  apSpecialty4: new InvoiceCheckDefinition('AP Specialty 4', false, 4, 70),
  apSpecialty5: new InvoiceCheckDefinition('AP Specialty 5', false, 5, 71),
  dueDateAndTime: new InvoiceCheckDefinition('Due Date & Time', true, 6, 72),
  dateAndTimeRequestReceived: new InvoiceCheckDefinition(
    'Date & Time Request Received',
    true,
    6,
    73
  ),
  proxiedByUser: new InvoiceCheckDefinition('Proxied By', true, 6, 74),
  ownerName: new InvoiceCheckDefinition('Owner', true, 7, 75),
};
